module.exports = __webpack_public_path__ + "img/hero-home.93a4c195.jpg";